import { render, staticRenderFns } from "./market01.vue?vue&type=template&id=0bd5e1d8&scoped=true&"
import script from "./market01.vue?vue&type=script&lang=js&"
export * from "./market01.vue?vue&type=script&lang=js&"
import style0 from "./market01.vue?vue&type=style&index=0&id=0bd5e1d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5e1d8",
  null
  
)

export default component.exports